import { render, staticRenderFns } from "./RecentCollections.vue?vue&type=template&id=0118d646&scoped=true&"
import script from "./RecentCollections.vue?vue&type=script&lang=js&"
export * from "./RecentCollections.vue?vue&type=script&lang=js&"
import style0 from "./RecentCollections.vue?vue&type=style&index=0&id=0118d646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0118d646",
  null
  
)

export default component.exports